import React from 'react'
import { useWindowWidth } from '@react-hook/window-size'
import { theme } from 'antd'
import { useMatches } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { RouteHandle } from '../../../routes/Route'
import { ContextFiltersSections } from '../types'

import ContextCompanySelect from '../../../components/GlobalHeader/ContextCompanySelect'
import ContextDimensionSelect from './ContextDimensionSelect'
import ContextPeriodSelect from './ContextPeriodSelect'
import ContextFiscalYearSelect from './ContextFiscalYearSelect'
import ContextScenarioSelect from './ContextScenarioSelect'
import ContextSettingsButton from './ContextSettingsButton'
import './ContextFilterToolbar.css'

const ContextFilterToolbar: React.FC = () => {
  const companyId = useSelector(contextCompanyIdSelector)

  const windowWidth = useWindowWidth()
  const compact = windowWidth < 1200
  const { token } = theme.useToken()

  const matches = useMatches()
  const handle = matches.at(-1)?.handle as RouteHandle | undefined
  const contextFilters = handle?.contextFilters

  const showDimension = contextFilters?.includes(ContextFiltersSections.dimension) ?? false
  const showScenario = contextFilters?.includes(ContextFiltersSections.budgetScenario) ?? false
  const showPeriod = contextFilters?.includes(ContextFiltersSections.periodGroups) ?? false
  const showDataTypes = contextFilters?.includes(ContextFiltersSections.dataTypes) ?? false
  const showEmptyRows = contextFilters?.includes(ContextFiltersSections.emptyRows) ?? false
  const showSettings = showDataTypes || showEmptyRows

  return (
    <div
      data-cy="context-filter-toolbar"
      className={compact ? 'filter-toolbar compact' : 'filter-toolbar'}
      style={
        {
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          flex: 1,
          padding: '2px',
          overflow: 'clip',
          '--active-border-color': token.colorPrimary
        } as React.CSSProperties
      }
    >
      <ContextCompanySelect width={200} />
      {companyId && (
        <>
          {showDimension && <ContextDimensionSelect />}
          {showScenario && <ContextScenarioSelect />}
          {showPeriod && <ContextPeriodSelect />}
          {showPeriod && <ContextFiscalYearSelect />}
          {showSettings && (
            <ContextSettingsButton dataTypesDisabled={!showDataTypes} emptyRowsDisabled={!showEmptyRows} />
          )}
        </>
      )}
    </div>
  )
}

export default ContextFilterToolbar
